module.exports = {
  src: __webpack_public_path__ + "static/media/miysis_logo-832@75.jpg",
  width: 832,
  height: 192,
  toString: function() {return __webpack_public_path__ + "static/media/miysis_logo-832@75.jpg";},
  srcset: [__webpack_public_path__ + "static/media/miysis_logo-832@75.jpg" + " 832w"].join(', '),
  images: [
    {
      src: __webpack_public_path__ + "static/media/miysis_logo-832@75.jpg",
      width: 832,
      height: 192
    }
  ]
};